import { Controller, useWatch } from "react-hook-form";
import Input from "../global/Input";
import RadioInput from "../global/RadioInput";
import { selectStyle, selectTheme } from "../../styles/selectStyles";

import Select from "react-select";

import { useGetDictionary } from "../../hooks/useGetDictionary";
import { DictionaryType } from "../../types";
import ValidateError from "../global/ValidateError";

type Props = {
  control: any;
  errors: any;
  getValues: any;
  eventType:'edit'|'view'
};

function BookingPrivilege({ control, errors, getValues,eventType }: Props) {
  const { customers, inputs, shared }: DictionaryType =
    useGetDictionary();
  // const slotsOption = [
  //   { value: 30, label: inputs["30_mins"] },
  //   { value: 60, label: inputs["60_mins"] },
  //   { value: 90, label: inputs["90_mins"] },
  //   { value: 120, label: inputs["120_mins"] },
  //   { value: 150, label: inputs["150_mins"] },
  // ];
 
  return (
    <div className="flex flex-col gap-8 w-full">
      <h3 className="font-bold text-lg text-primary dark:text-white ">
        {customers.booking_privileges}
      </h3>
      <div className="flex gap-4 w-full mobile:flex-wrap">
        <div className="flex-1 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8 mobile:min-w-[200px]">
          <div className="col-span-1">
            <Controller
              name="booking_days_in_advance"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <Input
                  label={inputs.booking_days}
                  customClass={eventType === 'view'?'bg-[#f2f2f2]':''}
                  inputProps={{
                    ...field,
                    className:
                      "block w-full p-2 bg-gray-800 border border-gray-700 rounded-md",
                    type: "number",
                    onWheel: (e) => {
                      e.preventDefault();
                      //@ts-ignore
                      e.target.blur();
                    },
                    step: 0,
                  }}
                  title={inputs.days}
                />
              )}
            />
            {/* @ts-ignore */}
            {errors.booking_days_in_advance && <ValidateError />}
          </div>
          <div className="col-span-1">
            <Controller
              name="max_number_of_active_bookings"

              control={control}
              rules={{
                required: true,
              }}
              render={({ field }) => (
                <Input
                  label={inputs.max_number_of_active_bookings}
                  customClass={eventType === 'view'?'bg-[#f2f2f2]':''}
                  inputProps={{
                    ...field,
                    className:
                      "block w-full p-2 bg-gray-800 border border-gray-700 rounded-md",
                    type: "number",
                    onWheel: (e) => {
                      e.preventDefault();
                      //@ts-ignore
                      e.target.blur();
                    },
                    step: 0,
                  }}
                  title={inputs.bookings}
                />
              )}
            />
            {/* @ts-ignore */}
            {errors.max_number_of_active_bookings && (
              <p className="text-red-500 text-sm mt-1">
                {errors.max_number_of_active_bookings.message}
              </p>
            )}
          </div>
        </div>
       
      </div>
    </div>
  );
}

export default BookingPrivilege;
